import React, { useRef, useState } from "react";

import emailjs from "@emailjs/browser";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Container,
  Row,
  Col,
  Input,
  Alert,
  FormGroup,
  Label,
} from "reactstrap";

// core components
import MainNavbar from "components/Navbars/MainNavbar.js";
import MainFooter from "components/Footers/MainFooter.js";
import MainHeader from "components/Headers/MainHeader";

function Contact() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("about-me");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("about-me");
    };
  });
  const form = useRef();

  const [status, setStatus] = useState(null);
  const [visible, setVisible] = useState(true);

  const onDismiss = () => {
    setVisible(false);
  };

  const sendEmail = (e) => {
    console.log("[E]", form.current);
    e.preventDefault();

    emailjs

      .sendForm(
        "service_obz411f", // e.g., service_gmail

        "template_tyqj7hb", // e.g., template_contact

        form.current,

        "RzbEJmyMe8HXH_Fru" // e.g., your user/public key from EmailJS
      )

      .then(
        (result) => {
          console.log(result.text);

          setStatus("SUCCESS");

          form.current.reset();
        },

        (error) => {
          console.log("ERROR", error.text);

          setStatus("FAILED");
        }
      );
  };

  return (
    <>
      {status === "SUCCESS" && (
        <Alert
          color="success"
          isOpen={visible}
          toggle={onDismiss}
          className="mb-0"
          style={{
            zIndex: 9999,
            position: "relative",
          }}
        >
          ✅ Your message has been sent!
        </Alert>
      )}

      {status === "FAILED" && (
        <Alert
          color="warning"
          isOpen={visible}
          className="mb-0"
          toggle={onDismiss}
          style={{
            zIndex: 9999,
            position: "relative",
          }}
        >
          ❌ Failed to send. Please try again.
        </Alert>
      )}
      <MainNavbar />
      <div className="main">
        <MainHeader title="Contact" />

        <div className="section landing-section">
          <Container>
            <h1 className="text-center"> Let's Keep in Touch... </h1>
            <Row>
              <Col className="ml-auto mr-auto text-center" md="6">
                <h3 className="title">Reach out on social media!</h3>
                <Button
                  className="btn-just-icon btn-round mr-1"
                  href="https://x.com/svelascova?lang=en>"
                  target="_blank"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-twitter-x"
                    viewBox="0 0 16 16"
                  >
                    <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                  </svg>
                </Button>
                <Button
                  className="btn-just-icon mr-1"
                  color="google"
                  href="mailto:shannenvelascova@gmail.com"
                >
                  <i className="fa fa-google" />
                </Button>
                <Button
                  className="btn-just-icon mr-1"
                  color="instagram"
                  href="https://www.instagram.com/shannenvelasco_va/"
                  target="_blank"
                >
                  <i className="fa fa-instagram" />
                </Button>
                <Button
                  className="btn-just-icon"
                  color="youtube"
                  href="https://www.youtube.com/@ShannenVelasco_VA"
                  target="_blank"
                >
                  <i className="fa fa-youtube" />
                </Button>
              </Col>
            </Row>
            <Row>
              <Col className="ml-auto mr-auto" md="6">
                <h3 className="title text-center">Or drop me a note!</h3>
                <form ref={form} onSubmit={sendEmail}>
                  <FormGroup>
                    <Label for="name">Name</Label>
                    <Input type="text" name="name" id="name" required />
                  </FormGroup>

                  <FormGroup>
                    <Label for="email">Email</Label>
                    <Input type="email" name="email" id="email" required />
                  </FormGroup>

                  <FormGroup>
                    <Label for="message">Message</Label>
                    <Input
                      type="textarea"
                      name="message"
                      id="message"
                      rows="4"
                      required
                    />
                  </FormGroup>

                  <Button color="danger" type="submit" block>
                    Send Message
                  </Button>
                </form>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <MainFooter />
    </>
  );
}

export default Contact;
